import { Injectable } from '@angular/core';

@Injectable()
export class PluginUtilsService {
  public getValueFromPercentage(
    value: number,
    lowerLimit: number,
    upperLimit: number
  ) {
    return Math.round((upperLimit - lowerLimit) * (value / 100));
  }

  public getValueToPercentage(
    value: number,
    lowerLimit: number,
    upperLimit: number
  ) {
    return Math.round(value / (upperLimit - lowerLimit) * 100);
  }

  public getValueByMultiplying(value: number, multiplicand: number) {
    return Math.round(value * multiplicand);
  }

  public getValueByDividing(value: number, dividend: number) {
    return Math.round(value / dividend);
  }
}
